import api from './api';
import { createFormData } from './api';

// Register a new user
export const register = async (userData) => {
  try {
    // Make sure we're sending the data in the format the API expects
    const formData = createFormData({
      ...userData,
      ip: userData.ip || '127.0.0.1',
      g_score: userData.g_score || ''
    });

    const response = await api.post('/registration', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true // Ensure cookies are sent/received
    });
    console.log('Registration response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Registration error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Login user
export const login = async (credentials) => {
  try {
    const formData = createFormData({
      ...credentials,
      ip: '127.0.0.1', // This would normally be handled by the server
      g_score: 'g_score' // This would normally be handled by the server
    });

    const response = await api.post('/login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true // Ensure cookies are sent/received
    });

    console.log('Login response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Login error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Logout user
export const logout = async () => {
  try {
    const response = await api.get('/logout', {
      withCredentials: true // Ensure cookies are sent/received
    });

    console.log('Logout response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Logout error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Get current user info
export const getCurrentUser = async () => {
  try {
    console.log('Making request to /me endpoint with session cookie');
    const response = await api.get('/me', {
      withCredentials: true // Ensure cookies are sent/received
    });
    console.log('Response from /me:', response.data);
    return response.data;
  } catch (error) {
    // Log detailed error information
    console.error('Error in getCurrentUser:', {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });

    // If it's an authentication error, just return null instead of throwing
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      console.log('Authentication error detected, returning null');
      return null;
    }
    // For other errors, throw as usual
    throw error.response ? error.response.data : error;
  }
};

// Start session with email token
export const startSession = async (email, token) => {
  try {
    const formData = createFormData({ email, token });
    console.log('Starting session with:', { email, token });
    const response = await api.post('/start-session', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true // Ensure cookies are sent/received
    });
    console.log('Start session API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Start session API error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Confirm email with token
export const confirmEmail = async (email, code) => {
  try {
    const formData = createFormData({ email, token: code });
    console.log('Sending email confirmation request with:', { email, token: code });
    const response = await api.post('/confirm-email', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true // Ensure cookies are sent/received
    });
    console.log('Email confirmation API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Email confirmation API error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Request a new confirmation email
export const requestConfirmEmail = async (email) => {
  try {
    const formData = createFormData({ email });
    console.log('Requesting confirmation email for:', email);
    const response = await api.post('/request-confirm-email', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true // Ensure cookies are sent/received
    });
    console.log('Request confirm email API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Request confirm email API error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Request password reset email
export const requestPasswordReset = async (email) => {
  try {
    const formData = createFormData({ email });
    console.log('Requesting password reset for:', email);
    const response = await api.post('/password/reset', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log('Password reset request API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Password reset request API error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};

// Reset password with token
export const resetPassword = async (email, token, password) => {
  try {
    const formData = createFormData({ email, token, password });
    console.log('Resetting password for:', email);
    const response = await api.post('/password', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    console.log('Password reset API response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Password reset API error:', error.response?.data || error.message);
    throw error.response ? error.response.data : error;
  }
};
